package one.healthium.log_period.di

import one.healthium.log_period.data.AppPeriodTrackerRepository
import one.healthium.log_period.domain.PeriodTrackerInteractor
import one.healthium.log_period.domain.PeriodTrackerRepository
import one.healthium.log_period.ui.utils.PeriodCalendarViewModel
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val logPeriodModule = module {
    singleOf(::AppPeriodTrackerRepository) bind PeriodTrackerRepository::class
    viewModelOf(::PeriodCalendarViewModel)
    factoryOf(::PeriodTrackerInteractor)
}